import { Spinner, Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { useRestrictedResourcesList } from './api/restricted-resources'
import { RestrictedResource } from './components/RestrictedResource'

export const RestrictedData = () => {
  const { data: resourcesList, isFetching } = useRestrictedResourcesList()

  return (
    <div className="flex flex-col gap-8 py-8">
      <div className="flex flex-col gap-4">
        <Text type="h4">
          <Trans>Restricted Data</Trans>
        </Text>
        <Text type="body1-regular" className="max-w-[770px] text-[var(--colorGray80to90)]">
          <Trans>
            We are committed to safeguarding your privacy. The application utilizes authentication solely to grant
            access to specific, secure content that is available exclusively to logged-in users. Your personal
            information will not be used or stored beyond the authentication process. Additionally, as a participant in
            this program, you will earn{' '}
            <span className="font-bold text-[var(--color70to100)]">extra points as a reward for your engagement</span>.
          </Trans>
        </Text>
      </div>
      {!resourcesList?.length && isFetching && (
        <div className="flex w-full justify-center">
          <Spinner className="mt-8" />
        </div>
      )}
      {resourcesList?.length ? (
        <ul className="flex flex-col gap-8">
          {resourcesList.map((resource) => (
            <li key={resource.id}>
              <RestrictedResource resource={resource} />
            </li>
          ))}
        </ul>
      ) : (
        !isFetching && (
          <div className="m-auto mt-8 max-w-[350px] rounded-xl bg-[var(--color-gray-100)] p-6">
            <Text>{'No resources available at the moment.'}</Text>
          </div>
        )
      )}
    </div>
  )
}
